var _Input$baseStyle;

import { mode } from "@chakra-ui/theme-tools";
import Input from "./input";
var parts = ["field", "stepper", "stepperGroup"];
var {
  variants,
  defaultProps
} = Input;
var baseStyleField = (_Input$baseStyle = Input.baseStyle) == null ? void 0 : _Input$baseStyle.field;
var baseStyleStepperGroup = {
  width: "24px"
};

function baseStyleStepper(props) {
  return {
    borderLeft: "1px solid",
    borderColor: mode("inherit", "whiteAlpha.300")(props),
    color: mode("inherit", "whiteAlpha.800")(props),
    _active: {
      bg: mode("gray.200", "whiteAlpha.300")(props)
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  };
}

var baseStyle = function baseStyle(props) {
  return {
    field: baseStyleField,
    stepperGroup: baseStyleStepperGroup,
    stepper: baseStyleStepper(props)
  };
};

function getSize(size) {
  var _Input$sizes;

  var sizeStyle = (_Input$sizes = Input.sizes) == null ? void 0 : _Input$sizes[size];
  var radius = {
    lg: "md",
    md: "md",
    sm: "sm"
  };
  return {
    field: sizeStyle == null ? void 0 : sizeStyle.field,
    stepper: {
      fontSize: size === "lg" ? "14px" : "10px",
      _first: {
        borderTopRightRadius: radius[size]
      },
      _last: {
        borderBottomRightRadius: radius[size],
        mt: "-1px",
        borderTopWidth: 1
      }
    }
  };
}

var sizes = {
  sm: getSize("sm"),
  md: getSize("md"),
  lg: getSize("lg")
};
export default {
  parts,
  baseStyle,
  sizes,
  variants,
  defaultProps
};
//# sourceMappingURL=number-input.js.map